import ExamIcon from 'img/icons/offering_icons/exam_icon.svg';
import { ExamStatus } from 'types/exam';
import {
  BodyRowType,
  HeaderIconConfig,
  IconType,
  OfferingTypeConfig,
} from '../utils/types';
import { formatExamStatusRows, formatProductRows } from '../BodyBuilder/utils';

const examIconConfig: HeaderIconConfig = {
  backgroundColor: '#004153',
  iconTitle: 'Delivery format: Exam',
  src: ExamIcon,
};

const examConfig: OfferingTypeConfig = {
  actionButtons: ({ displayProgress, entry, catalogStore, t }) => {
    const link = catalogStore.getCatalogEntryLink(entry);
    if (!link) {
      return {};
    }

    return {
      actionButtonA: {
        buttonLabel: displayProgress ? t('Continue') : t('View'),
        href: link.href,
        icon: IconType.Arrow,
        onClick: link.navigate,
      },
    };
  },
  bodyRowsLayout: () => [BodyRowType.Custom],
  buildCustomRows: ({ examStatusInfo, offeringProducts, t }) => {
    if (examStatusInfo?.status !== ExamStatus.Unenrolled)
      return formatExamStatusRows(examStatusInfo, t);
    return formatProductRows(offeringProducts);
  },
  headerConfig: ({ t }) => ({
    iconB: examIconConfig,
    title: t('Exam'),
  }),
};

export default examConfig;
